import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { DnaOligo } from 'src/models';
import { set } from 'src/core/redux/actions';
import { selectStateData } from 'src/core/redux/selectors';
import { STEPS_NAMESPACE_ACTION } from 'src/constants/forms';
import { getCountryCode } from 'src/utils';

export default (WrappedComponent) => {
  const Component = ({
    dnaSteps = [],
    updateStepsData,
    ...props
  }) => {
    const selectedStep = dnaSteps?.find((step) => step?.isActive) || {};

    const updateSteps = (stepName) => {
      updateStepsData(dnaSteps.map((stepData) => {
        if (selectedStep) {
          selectedStep.isComplete = true;
        }

        return {
          ...stepData,
          isVisited: stepData.name === stepName ? true : stepData.isVisited,
          isActive: stepData.name === stepName
        };
      }));
    };

    useEffect(() => {
      if (!dnaSteps?.length) {
        updateStepsData(DnaOligo.getDefaultStepsState());
      }
    }, [dnaSteps, updateStepsData]);

    return (
      <WrappedComponent
        {...{
          ...props,
          dnaSteps,
          selectedStep,
          updateSteps,
          countryCode: getCountryCode()
        }}
      />
    );
  };

  Component.propTypes = {
    dnaSteps: PropTypes.array,
    updateStepsData: PropTypes.func.isRequired,
  };

  const mapStateToProps = (state) => ({
    dnaSteps: selectStateData(STEPS_NAMESPACE_ACTION)(state),
  });

  const mapDispatchToProps = (dispatch) => ({
    updateStepsData: (newStepsData) => dispatch(set(STEPS_NAMESPACE_ACTION, '', newStepsData)),
  });

  return connect(mapStateToProps, mapDispatchToProps)(Component);
};
